import React from 'react';
import { Link } from 'react-router-dom';
import Chevron from '../../../components/content/Chevron';
import { useWebLocale } from '../../../contexts/WebLocaleContext';
import baseline, { appCopy, appTextStyle } from '../../../app-ui/baseline';
import { resultCategoryLabel } from '../../../features/search/resultPresentation';
export default function SearchCategoryHeading({ category, query = '', mobile = false }) {
  const { locale } = useWebLocale();
  return (
    <div
      className={`pp-search-category-heading ${mobile ? 'pp-search-category-mobile' : 'pp-search-category-desktop'}`}
    >
      <Link
        to={`/search/summary?q=${encodeURIComponent(query)}`}
        aria-label={appCopy(locale, 'search.backToResults')}
        className="pp-search-back"
      >
        <Chevron />
      </Link>
      <div>
        <h1 style={appTextStyle(baseline.tokens.typography.artistTitle)}>
          {appCopy(locale, 'search.categoryResultsTitle', {
            category: resultCategoryLabel(category, locale),
          })}
        </h1>
        <p style={appTextStyle(baseline.contentText.metadata)}>“{query}”</p>
      </div>
    </div>
  );
}
